export function updateInvoices(invoices) {
    return {
        type: 'UPDATE_INVOICES',
        invoices
    }
}
